<template>
  <div>
    <az-call-to-action active @click="iniciarInclusaoNovoMembro">
      <v-icon>add_circle</v-icon>
      Novo
    </az-call-to-action>
    <az-modal v-if="incluindoMembro">
      <span slot="title">Novo Membro</span>
      <v-container grid-list-md slot="body">
        <v-layout wrap>
          <v-flex xs12>
            <v-card>
              <v-card-text>
                <v-autocomplete
                    v-model="comissaoUsuarioNovo.usuario"
                    :items="candidatos"
                    label="Usuário"
                    name="Usuário"
                    :error-messages="errors.collect('Usuário')"
                    v-validate="'required'"
                    persistent-hint
                >
                  <template v-slot:append-outer>
                    <v-slide-x-reverse-transition
                        mode="out-in"
                    >
                    </v-slide-x-reverse-transition>
                  </template>
                </v-autocomplete>

                <v-autocomplete
                    v-model="comissaoUsuarioNovo.atribuicao"
                    :items="funcoes"
                    label="Atribuição"
                    name="Atribuição"
                    :error-messages="errors.collect('Atribuição')"
                    v-validate="'required'"
                    persistent-hint
                >
                  <template v-slot:append-outer>
                    <v-slide-x-reverse-transition
                        mode="out-in"
                    >
                    </v-slide-x-reverse-transition>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div class="az-actions-form" slot="actions">
        <div class="align-left"></div>
        <div class="align-right">
          <button class="action-secundary" @click="cancelarInclusao">Cancelar</button>
          <button class="action-primary" @click.prevent="salvar">Salvar</button>
        </div>
      </div>
    </az-modal>
    <az-modal v-if="mostrarAvisoPresidente">
      <template #title>
        <v-icon color="warning" left class="mr-2">mdi-alert</v-icon>
        Confirmação de Presidente
      </template>
      <div slot="body">
        <v-card flat class="pa-3">
          <v-card-text class="text-subtitle-1 text--primary d-flex align-center">
            <span v-html="mensagemAvisoPresidente"></span>
          </v-card-text>
        </v-card>
      </div>
      <template #actions>
        <div class="d-flex justify-end gap-3">
          <v-btn class="action-secundary" color="grey lighten-1" outlined rounded @click="fecharAviso">
            Cancelar
          </v-btn>
          <v-btn class="action-primary" color="primary" elevation="2" rounded @click="confirmarAviso">
            Sim, continuar
          </v-btn>
        </div>
      </template>
    </az-modal>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {actionTypes} from '@/commons/constants'

export default {
  name: 'ComissaoDadosMembrosNovo',
  data() {
    return {
      funcoes: [
        'Agente de Contratação',
        'Autoridade Competente',
        'Comissão Especial',
        'Equipe de Apoio',
        'Especialista Técnico',
        'Leiloeiro',
        'Membro',
        'Membro da Equipe',
        'Pregoeiro',
        'Presidente',
        'Servidor Designado',
        'Subcomissão Técnica'
      ],
      incluindoMembro: false,
      candidatos: [],
      comissaoUsuarioNovo: {},
      pendingMembro: null,
      mostrarAvisoPresidente: false,
      mensagemAvisoPresidente: ''
    }
  },
  computed: {
    ...mapState(['comissao'])
  },
  methods: {
    ...mapActions([
      actionTypes.BUSCAR_CANDIDATOS_COMISSAO,
      actionTypes.BUSCAR_COMISSAO_APURACAO,
      actionTypes.INSERIR_MEMBRO_COMISSAO
    ]),
    cancelarInclusao() {
      this.incluindoMembro = false
      this.comissaoUsuarioNovo = {}
    },
    async iniciarInclusaoNovoMembro() {
      this.setMensagemLoading('Carregando usuários...')
      await this.prepararCandidatosSelecao()
      this.incluindoMembro = true
    },
    async inserirNovoMembro() {
      this.setMensagemLoading('Adicionando membro na comissão...')
      await this.inserirMembroComissao({
        comissaoId: this.comissao.comissaoApuracao.id,
        comissaoUsuario: this.comissaoUsuarioNovo
      })
    },
    async prepararCandidatosSelecao() {
      const that = this
      this.candidatos = []
      const candidatos = await this.buscarCandidatosComissao(this.comissao.comissaoApuracao.id)
      candidatos.forEach(candidato => that.candidatos.push({text: candidato.nome, value: candidato}))
    },
    async salvar() {
      const validado = await this.$validator._base.validateAll()
      if (!validado){
        this.mostrarNotificacaoErro("Preencha os campos obrigatórios.")
        return
      }

      const tinhaAgente = this.comissao.comissaoUsuarios.some(u => u.cargo === 'Agente de Contratação')
      const tinhaPregoeiro = this.comissao.comissaoUsuarios.some(u => u.cargo === 'Pregoeiro')

      this.pendingMembro = {
        comissaoId: this.comissao.comissaoApuracao.id,
        comissaoUsuario: this.comissaoUsuarioNovo
      }

      if (this.comissaoUsuarioNovo.cargo === 'Pregoeiro' && tinhaAgente) {
        this.mensagemAvisoPresidente = `<strong style="color: red;">Atenção:</strong> ao adicionar este usuário como Pregoeiro, ele passará a ser o presidente da comissão. Deseja continuar?`
        this.mostrarAvisoPresidente = true
        return
      }
      if (this.comissaoUsuarioNovo.cargo === 'Agente de Contratação' && tinhaPregoeiro) {
        this.mensagemAvisoPresidente = `<strong style="color: red;">Atenção:</strong> ao adicionar este usuário como Agente de Contratação, ele passará a ser o presidente da comissão. Deseja continuar?`
        this.mostrarAvisoPresidente = true
        return
      }
      if (this.comissaoUsuarioNovo.cargo === 'Agente de Contratação' && tinhaAgente) {
        this.mensagemAvisoPresidente = `<strong style="color: red;">Atenção:</strong> ao adicionar este usuário como Agente de Contratação, ele passará a ser o presidente da comissão. Deseja continuar?`
        this.mostrarAvisoPresidente = true
        return
      }

      await this.executarInclusao()
    },

    async confirmarAviso() {
      this.mostrarAvisoPresidente = false
      await this.executarInclusao()
    },

    fecharAviso() {
      this.mostrarAvisoPresidente = false
    },

    async executarInclusao() {
      await this.inserirMembroComissao(this.pendingMembro)
      await this.buscarComissaoApuracao(this.comissao.comissaoApuracao.id)
      this.mostrarNotificacaoSucessoDefault()
      this.incluindoMembro = false
      this.comissaoUsuarioNovo = {}
      this.pendingMembro = null
    }
  }
}
</script>